import type { FaireProductEntity } from "../../entity_types/product";

export const p_gyp3qyb4ms: FaireProductEntity = {
  token: "p_gyp3qyb4ms",
  type: "product",
  name: "Super Sunny Thank You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/17baf3fa104473c4b3943f18f4efc307dd52c23eefa05128f24c6dfbe0d7430d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9d707e9118afb0875c8775dbe9e4b373bad188b29752b8ae38c7b0230e3bc6eb.png",
    "https://cdn.faire.com/fastly/74ab1cd9106044f417b52f0e044809290a67c60ba1caf2733f3d7dce8df65fb0.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:10.352Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
